import styled from 'styled-components';

export const SchedulesItemContainer = styled.div<{ $show: boolean; $displayed: boolean }>`
  display: ${({ $show }) => ($show ? 'block' : 'none')};
  margin-top: 1rem;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.white.a10};
  box-shadow: ${({ $displayed }) =>
    $displayed ? '0 4px 30px 0 rgba(0, 0, 0, 0.2)' : '0 4px 30px 0 rgba(0, 0, 0, 0.03)'};
  font-size: 1.4rem;
`;

export const TemplateContainer = styled.div<{ $show: boolean }>`
  display: ${({ $show }) => ($show ? 'block' : 'none')};
`;

export const SchedulesItemHeader = styled.div`
  display: flex;
  padding: 1.333rem 2rem;
  align-items: center;
`;

export const SchedulesHeaderText = styled.span`
  flex-grow: 1;
`;

export const LoadingContainer = styled.div`
  padding: 30px;
  border-top: 7px solid ${({ theme }) => theme.black.a1};
`;
